import { IOrganisationUserInvite } from '@liquid-state/pephealth-client';

export interface DirectChildOrganisationUserInvitationValues {
  organisationSlug: string;
  email: string;
  firstName: string;
  lastName: string;
  role: 'admin' | 'member';
  language: string;
  careTeamMember: boolean;
}

export interface DirectChildOrganisationUserInvitation {
  organisationSlug: string;
  invite: IOrganisationUserInvite;
}

export const toDirectChildOrganisationUserInvitation = ({
  organisationSlug,
  email,
  firstName,
  lastName,
  role,
  language,
  careTeamMember,
}: DirectChildOrganisationUserInvitationValues): DirectChildOrganisationUserInvitation => ({
  organisationSlug,
  invite: {
    email,
    firstName,
    lastName,
    role,
    language,
    careTeamMember,
  },
});
